<script setup lang="ts">
import type { SheetVariants } from '@layers/ui/app/components/ui/sheet'

const props = defineProps<{
  side?: SheetVariants['side']
}>()

const { t } = useI18n()

const open = defineModel('open', {
  default: false,
})

function handleClose() {
  open.value = false
}
</script>

<template>
  <UiSheet v-model:open="open">
    <UiSheetContent :side="props.side" class="max-w-md w-full flex flex-col overflow-hidden p-0 sm:max-w-md">
      <UiSheetTitle class="sr-only">
        {{ t('navigation.drawer.title') }}
      </UiSheetTitle>
      <UiSheetDescription class="sr-only">
        {{ t('navigation.drawer.description') }}
      </UiSheetDescription>

      <NavigationDrawerHeader @close="handleClose" />

      <div class="flex-1 overflow-y-auto">
        <NavigationDrawerBody @close="handleClose" />
      </div>
    </UiSheetContent>
  </UiSheet>
</template>
